import React, { useMemo } from 'react';
import { AiAssistant } from './AiAssistant';
import { MockAiAssistantClient } from './client/MockAiAssistantClient';
export const AiAssistantWrapper = ({ accessToken, children }) => {
    const client = useMemo(() => new MockAiAssistantClient(), []);
    // Temporary rollout gate for this WIP feature — remove once ready for everyone.
    const isEnabled = localStorage.getItem('aiAssistantEnabled') === 'true';
    return (React.createElement(React.Fragment, null,
        children,
        accessToken && isEnabled && React.createElement(AiAssistant, { client: client })));
};
